import React from "react";
import {
  ApplicabilityStrategy,
  GeoApplicabilityConfig,
  UnderwritingPolicyAttachmentStatus,
} from "../../models/underwritingPolicyAttachment";
import { splitKeyWithSpace } from "../../utils";
import { SEGMENT_EXPLAIN_URL } from "../../config";

// UI-only display rename: SHADOW -> "DRAFT". Enum/API values are untouched.
export function getDisplayStatus(status: UnderwritingPolicyAttachmentStatus): string {
  if (status === UnderwritingPolicyAttachmentStatus.SHADOW) return "DRAFT";
  return splitKeyWithSpace(status);
}

export const renderSegmentIdLink = (segmentId?: string) => {
  if (!segmentId) return "-";
  if (!SEGMENT_EXPLAIN_URL) return segmentId;
  const href = SEGMENT_EXPLAIN_URL.replace(
    "{segment_id}",
    encodeURIComponent(segmentId)
  );
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {segmentId}
    </a>
  );
};

export const getGoogleMapsPointUrl = (circle?: GeoApplicabilityConfig["circle"]) => {
  if (!circle) return undefined;
  return `https://www.google.com/maps?q=${circle.lat},${circle.lng}`;
};

export const getBboxFinderUrl = (boundingBox?: GeoApplicabilityConfig["boundingBox"]) => {
  if (!boundingBox) return undefined;
  return `https://bboxfinder.com/#${boundingBox.minLat},${boundingBox.minLng},${boundingBox.maxLat},${boundingBox.maxLng}`;
};

export const renderApplicabilityMetadata = (metadata?: {
  strategy: ApplicabilityStrategy;
  userIdSuffixes: string[];
  segmentId?: string;
}) => {
  if (!metadata) return null;
  const { strategy, ...restMeta } = metadata;
  if (strategy === ApplicabilityStrategy.SEGMENT) {
    return <>SEGMENT ({renderSegmentIdLink(restMeta.segmentId)})</>;
  }
  if (strategy === ApplicabilityStrategy.USER_ID_SUFFIX) {
    return `USER_ID_SUFFIX (${restMeta.userIdSuffixes.join(", ")})`;
  }
  return `${strategy} (${JSON.stringify(restMeta, undefined, 2)})`;
};
